// @flow
import { defineMessages } from 'react-intl';

export const SECONDS = 'SECONDS';
export const MINUTES = 'MINUTES';
export const HOURS = 'HOURS';
export const DAYS = 'DAYS';
export const WEEKS = 'WEEKS';
export const MONTHS = 'MONTHS';
export const YEARS = 'YEARS';

export const messages = defineMessages({
    a: {
        id: 'time-unit.a',
        defaultMessage: 'a'
    },
    an: {
        id: 'time-unit.an',
        defaultMessage: 'an'
    },
    hour: {
        id: 'time-unit.hour',
        defaultMessage: 'hour'
    },
    hours: {
        id: 'time-unit.hours',
        defaultMessage: 'hours'
    },
    minute: {
        id: 'time-unit.minute',
        defaultMessage: 'minute'
    },
    minutes: {
        id: 'time-unit.minutes',
        defaultMessage: 'minutes'
    },
    now: {
        id: 'time-unit.now',
        defaultMessage: 'now'
    },
    tomorrow: {
        id: 'time-unit.tomorrow',
        defaultMessage: 'tomorrow'
    }
});



// WEBPACK FOOTER //
// ./src/core/constants/time-units.js